<script>
import { authMethods, authComputed } from '@state/helpers'
import AuthLayout from '@layouts/auth.vue'

export default {
  page: {
    title: 'Prisijungimas',
  },

  components: { AuthLayout },

  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      errorMessage: null,
      isLoading: false,
    }
  },

  computed: {
    ...authComputed,
  },

  methods: {
    ...authMethods,

    onSubmitForm() {
      this.isLoading = true
      this.errorMessage = null

      return this.logIn(this.form)
        .then((token) => {
          if (['coordinator', 'admin'].includes(this.currentUser.role)) {
            this.$router.push(
              this.$route.query.redirectFrom || { name: 'users' },
            )
          } else {
            this.$router.push(
              this.$route.query.redirectFrom || { name: 'availability' },
            )
          }
        })
        .catch(() => {
          this.isLoading = false
          this.errorMessage = 'Neteisingas el. pašto adresas arba slaptažodis.'
        })
    },
  },
}
</script>

<template>
  <AuthLayout>
    <template v-slot:title> Prisijungimas </template>

    <p v-if="errorMessage" class="text-error mb-4">
      {{ errorMessage }}
    </p>

    <form @submit.prevent="onSubmitForm">
      <div class="mb-4">
        <base-label-input
          v-model="form.email"
          type="email"
          name="email"
          label="El. pašto adresas"
          :error="!!errorMessage"
          autofocus
        />
      </div>

      <div class="mb-4">
        <base-label-input
          v-model="form.password"
          name="password"
          label="Slaptažodis"
          type="password"
          :error="!!errorMessage"
        />
      </div>

      <div>
        <base-submit :loading="isLoading"> Prisijungti </base-submit>
      </div>
    </form>

    <div class="mt-8 text-center font-medium text-sm">
      <router-link :to="{ name: 'password-remind' }">
        Pamiršai slaptažodį?
      </router-link>
    </div>
  </AuthLayout>
</template>
